const t = "Genomfört steg", o = "Tillbaka till {buttonName}", e = "Fortsätt till {buttonName}", n = {
  completedStep: t,
  backButton: o,
  nextButton: e
};
export {
  o as backButton,
  t as completedStep,
  n as default,
  e as nextButton
};
